module.exports = __webpack_public_path__ + "static/whiteLogo-907719d6bc91a622bff82eaa09615349.png";